<template>
    <div class="creatAccount">
        <h2>Create Account</h2>
        <p>Sign up to access TVU Search</p>
        <div class="form">
            <el-form :model="accountInfo" ref="accountForm" :rules="rule">
                <el-row>
                    <el-col :span="11">
                        <el-form-item
                            prop="firstName"
                            :rules="[{ required: true, message: 'please enter first name', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="accountInfo.firstName"
                                placeholder="First name"
                                :maxlength="32"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">&nbsp;</el-col>
                    <el-col :span="11">
                        <el-form-item
                            prop="lastName"
                            :rules="[{ required: true, message: 'please enter last name', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="accountInfo.lastName"
                                placeholder="Last Name"
                                :maxlength="32"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="email"
                            :rules="[{ required: true, message: 'please enter email address', trigger: 'blur' },
                            { pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ , message: 'format valid', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="accountInfo.email"
                                placeholder="Business/Company Email Address"
                                :maxlength="100"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="company"
                            :rules="[{ required: true, message: 'please enter company name', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="accountInfo.company"
                                placeholder="Please enter Company name"
                                :maxlength="128"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="organization" :rules="[{ required: true, message: 'please select organization', trigger: 'change' }]">
                            <el-select placeholder="The type of organization" v-model="accountInfo.organization">
                                <el-option label="Broadcaster" value="broadcaster"></el-option>
                                <el-option label="News Service - Newspaper, Digital News etc." value="newsService"></el-option>
                                <el-option label="Public Institution" value="publicInstitution"></el-option>
                                <el-option label="education" value="education"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="country" :rules="[{ required: true, message: 'please select country', trigger: 'change' }]">
                            <el-select placeholder="Please select country" v-model="accountInfo.country">
                               <el-option v-for="(val,i) in country.country" :key="i" :label="val.val" :value="val.val"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="btn clearfix">
            <span class="f_l">
                <a @click="signIn">Sign In</a>
            </span>
            <el-button class="f_r" @click="validateForm" :disabled="!isSendAjax">Next</el-button>
        </div>
        <div class="foot-box">
            <span>By registering with TVU Networks, you accept  our </span>
            <a href="https://www.tvunetworks.com/company-content-license-agreement/" target="blank">Content license agreement,</a>
            <a href="https://www.tvunetworks.com/company-privacy-notice/" target="blank">Privacy policy </a>
            <span>and </span>
            <a href="https://www.tvunetworks.com/company-terms-and-conditions/" target="blank">Terms and conditions</a>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
import country from '../../country'
export default {
    data(){
        return{
            accountInfo:{
                // activityCode:'307645',
                activityCode:'357306',
                service: 1,
                // organization: []
            },
            rule:{},
            errorCode: this.$store.state.errorCodeLink,
            hostName:window.location.host,
            isSendAjax:true,
            country,
        }
    },
    created(){
        
    },
    methods:{
        signIn(){
            gaAnalyze('lpSignIn');
            window.location.href = "http://" + window.location.host + '/userGroup/user-group/rgUser/redirectSignIn?service=1';
            // window.location.href = 'http://tvuservice.tvunetworks.com/tvuservice/?url=http://search.tvunetworks.com/mma&serviceName=Command Center';
        },
        // 验证项
        validateForm() {
            // this.$emit('showModule',{type:'next',module:'activate',back:'creat'});
            // return;
            let flag = false;
            this.$refs['accountForm'].validate((valid) => {
              flag = valid
            })

            gaAnalyze('lpCreatNext');
            if(!this.isSendAjax) return;
            if(flag){
                this.isSendAjax = false;
                this.axios.post('/userGroup/user-group/rgUser/register',this.accountInfo)
                .then(res => {
                    this.isSendAjax = true;
                    let linkName = this.errorCode[res.data.errorCode];
                    if(linkName){
                        this.$store.state.userId = res.data.result ? res.data.result.id : '';
                        this.$store.state.email = this.accountInfo.email;
                        this.$store.state.firstName = this.accountInfo.firstName;
                        this.$emit('showModule',{type:'next',module:linkName,back:'creat'});
                    }else{
                        this.$message.error(res.data.errorInfo)
                    }
                })
            }
        },
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    margin-bottom: 0.35rem;
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}
.is-disabled{
    background: #6BCB82 !important;
}
.el-select{
    width: 100%;
}
.foot-box{
    font-size: 12px;
    color: #666;
    margin-top: 30px;
    font-family: Helvetica;
    a{
        color: #1EC345;
    }
    a:hover{
        text-decoration: underline;
    }
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

